import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { MessageThread } from '../types/MessageThread';

const URL = '/v2/message-threads';

class MessageThreadService {
  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<MessageThread>> {
    return axios.get(URL, config);
  }

  static patch(
    id: number,
    data: Partial<MessageThread>,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<MessageThread>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }
}
export { MessageThreadService };
